import React, { useState, useEffect } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useTranslation } from "react-i18next";
import { uuid } from "../../../Utilities/shared";

const SelfClearingNumericTextBox = (props) => {
  const [state] = useState({
    id: uuid(),
  });

  const { t } = useTranslation();


  let isOnChange = false;
  let startToEdit = true;

  const clearInput = (e) => {

    if (props.disabled) return;
    if (!e.target.classList.contains("k-input")) return;
    if (props.noClear) return;
    if (isOnChange) {
      isOnChange = false;
      return;
    }

    console.log("updating...");

    props.update({
      target: {
        value: null,
      },
    });

    /*
            NumericTextBox doesn't respond to outside updates until the onBlur() event is triggered (at least
            at the time this code was written, if this is changed, please fix), thus the event is simulated to allow the
            field to clear as needed and then focus is returned so the user can provide input.
            */
    setTimeout(() => {
      const elem = document.getElementById(state.id);

      if (!elem) return;

      document.getElementById(state.id).blur();

      setTimeout(() => {
        document.getElementById(state.id).focus();
      }, 25);


    }, 25);
  };

  const onChange = (e) => {

    console.log("onChange()");

    isOnChange = true;

    if (e.value !== "" && e.value !== null) {
      props.update({
        target: {
          value: parseFloat(e.value)
        }
      });
      return;
    }

    isOnChange = true;
    props.update(e);
  };

  const onBlur = () => {
    console.log("onBlur()");

    const defaultValue = props.defaultValue ? props.defaultValue : 0;

    if (!startToEdit) {
      if (props.value === "" || props.value == null) {
        props.update({
          target: {
            value: defaultValue,
          },
        });
      }
      startToEdit = !startToEdit;
    } else {
      startToEdit = !startToEdit;
    }
  };

  let hideArrowsClass;
  if (props.format === "c2" || props.hideArrows) {
    hideArrowsClass = "hide-up-and-down";
  }

  const className = props.valid ? "self-clearing-input" : "self-clearing-input invalid-input";

  const value = props.value !== "" && props.value !== null ? parseFloat(props.value) : props.value;

  return (
      <span className={className} onClick={clearInput}>
      <NumericTextBox
          {...props}
          className={hideArrowsClass}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          id={state.id}
          placeholder={t("Global.placeholder")}
          validityStyles={true}
          spinners={!props.hideArrows}
      />
    </span>
  );
};

export default SelfClearingNumericTextBox;
